/**
 * BudouX（Google製の日本語分かち書き）で見出しを文節区切りで改行させる。
 * parse() で文節配列を得て、textNode と <wbr> 要素を DOM API で組み直す（innerHTML を使わず
 * XSS リスクを避ける）。word-break:keep-all / overflow-wrap:anywhere で意味の切れ目だけ折り返す。
 * jQuery不使用。
 * 対象: `data-budoux` 属性が付いた任意の要素（タグ・クラス問わず）。
 *   例) <p class="Servicedetail__ttlJa" data-budoux>…</p> ／ <h2 data-budoux>…</h2>
 *   HTML側で属性を付け外しするだけで適用対象を制御できる（JSのセレクタ変更不要）。
 * @example
 * // <p data-budoux>商品開発・リテール連動アドバイザリー</p> が自然な区切りで折り返す
 */
import { loadDefaultJapaneseParser } from "budoux"
import type { PageModule } from "./page-module"

/**
 * BudouX を scope 内の [data-budoux] の付いた全要素に適用（要素が無ければ何もしない＝通常の折り返しにフォールバック）。
 * @param {HTMLElement} scope - 走査の起点となる要素（現在ページの <main>）
 * @returns {void} リスナー等を張らないため destroy は返さない
 */
export const mountBudoux: PageModule = (scope) => {
  const targets = Array.from(scope.querySelectorAll<HTMLElement>("[data-budoux]"))
  if (targets.length === 0) return

  const parser = loadDefaultJapaneseParser()
  targets.forEach((el) => {
    if (el.dataset.budouxDone) return // 二重分かち書き防止（swupで再mountされても再処理しない）
    const segments = parser.parse(el.textContent ?? "")
    el.textContent = ""
    segments.forEach((seg, i) => {
      if (i > 0) el.appendChild(document.createElement("wbr")) // 文節の間だけ改行可能ポイント
      // budouxが語境界と見なさない中黒「・」の直後にも改行機会を補う（「商品開発・/リテール…」等）
      seg
        .split(/(?<=・)/)
        .filter(Boolean)
        .forEach((part, j) => {
          if (j > 0) el.appendChild(document.createElement("wbr"))
          el.appendChild(document.createTextNode(part))
        })
    })
    el.style.wordBreak = "keep-all"
    el.style.overflowWrap = "anywhere"
    el.dataset.budouxDone = "1"
  })
}
